module.exports = __webpack_public_path__ + "img/ico_search.c3bba538.svg";